/* eslint-disable react/no-unescaped-entities */
import React, {useState, useEffect} from "react";
import AnimatedPage from "../components/Animation/AnimatedPage";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { useSelector } from 'react-redux';
import Layout from "../components/layout";
import SetNewPassword from "../pages/auth/SetNewPassword";
import { Suspense, lazy } from "react";
import CommonLoader from "../CommonComponent/commonLoader";
import ViewProfileShimmer from "../pages/account/Profile/ViewProfile/profileShimmer";
import PricingShimmer from "../pages/Pricing/pricingShimmer";
import Register from "../pages/auth/RegistrationForm";
import ListingAuction from "../pages/Auction/listAuction";
import CreateAuction from "../pages/Auction/createAuction";
import ClassicTemplate from "../pages/Auction/createAuction/timedAuction/reviewPages";
import CreateLot from "../pages/Auction/createLot";
import AuctionView from "../pages/Auction/auctionView";
import Lots from "../pages/Auction/auctionView/lots";
import Overview from "../pages/Auction/auctionView/overview";
import Bidders from "../pages/Auction/auctionView/bidders";
import BidderDetails from "../pages/Auction/auctionView/bidders/bidderDetails";
import Sales from "../pages/Auction/auctionView/sales";
import OrderDetails from "../pages/Auction/auctionView/orderDetails";
import ViewBidsOfLot from "../pages/Auction/auctionView/lots/view";
import BidsList from "../pages/Auction/auctionView/bids";
import BidsShimmer from "../pages/Auction/auctionView/bids/bidsShimmer";
import AllBidders from "../pages/AllBidders";
import Custom404 from "../404";
import AllSales from "../pages/AllSales";
import DashboardShimmer from "../pages/Dashboard/dashboardShimmer";
import Insights from "../pages/Auction/auctionView/insights";
import ChooseType from "../pages/Auction/createAuction/ChooseType";
import LiveAuctionCreator from "../pages/Auction/createAuction/liveAuction/previewPages";
const Login = lazy(()=> import('../pages/auth/LoginForm')) 
const ResetPassword = lazy(()=>import('../pages/auth/ResetPassword'))
const Profile = lazy(() => import('../pages/account/Profile'))    
const Pricing = lazy(() => import('../pages/Pricing'))    
const Dashboard = lazy(()=>import('../pages/Dashboard'))
import CarouselView from "../pages/Auction/carousel-view";
import LeaderBoardView from "../pages/Auction/leaderboard-view";
import TelephoneBids from "../pages/Auction/auctionView/telephoneBids";
import AbsenteeBids from "../pages/Auction/auctionView/absenteeBids";

export default function NavigationRoutes(props) {
    const location = useLocation();
    const auth = useSelector(state=>state.registration);
    const pricingValues = useSelector((state) => state.pricingSlice);
    const price = pricingValues.plan_type || localStorage.getItem("plan_type") || "Free";
    const { loggedIn } = auth;

    const [isTopbarIsOpen, setIsTopBarIsOpen] = useState(true);

    return (
        <Routes location={location} key={location.pathname}>
            <Route
                path="*"
                element={(
                    <main style={{ padding: '1rem' }}>
                        <p>There's nothing here!</p>
                        <a><Navigate to="/" replace /></a>
                    </main>
                )}
            />
            <Route
                path="/page-not-found"
                element={(
                    <main style={{ padding: '1rem' }}>
                        <Custom404 />
                    </main>
                )}
            />
            <Route path="/verify_token" element={
                <AnimatedPage><SetNewPassword/></AnimatedPage>
            } />
            {!loggedIn ? (
                <>
                    <Route path="/" element={
                        new URLSearchParams(location.search).has('impersonate') ? (
                            <Navigate to={`/login${location.search}`} replace />
                        ) : (
                            <Suspense fallback={<CommonLoader/>}>
                                <AnimatedPage>
                                    <Register />
                                </AnimatedPage>
                            </Suspense>
                        )}
                    />
                    <Route path="/login" element={
                        <Suspense fallback={<CommonLoader/>}>
                            <AnimatedPage>
                                <Login/>
                            </AnimatedPage>
                        </Suspense>
                    }/>
                    <Route path="/reset-password" element={
                        <Suspense fallback={<CommonLoader/>}>
                            <AnimatedPage>
                                <ResetPassword/>
                            </AnimatedPage>
                        </Suspense>}/>
                </>
            )
                : (
                    <>
                        <Route element={
                            <Layout isTopbarIsOpen={isTopbarIsOpen} 
                                setIsTopBarIsOpen={setIsTopBarIsOpen} {...props} />
                        }>
                            <Route path="/" element={
                                <Suspense fallback={<DashboardShimmer/>}>
                                    <Dashboard/>
                                </Suspense>
                            } />
                            <Route path="/account" element={
                                <Suspense fallback={<ViewProfileShimmer/>}>
                                    {/* <AnimatedPage> */}
                                    <Profile/>
                                    {/* </AnimatedPage> */}
                                </Suspense>
                            } />
                            <Route path="/pricing" element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    {/* <AnimatedPage> */}
                                    <Pricing/>
                                    {/* </AnimatedPage> */}
                                </Suspense>} />
                            <Route path="/auctions" element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <ListingAuction/>
                                    </AnimatedPage>
                                </Suspense>
                            } />
                            <Route path="/allbidders" element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <AllBidders />
                                    </AnimatedPage>
                                </Suspense>} /> 
                            <Route path="/allsales" element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <AllSales />
                                    </AnimatedPage>
                                </Suspense>} /> 
                            <Route path="/auctions/:id/:uid/lots/view/:lotId" element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <ViewBidsOfLot/>
                                    </AnimatedPage>
                                </Suspense>} />
                            <Route element={<AuctionView {...props}/>}>
                                <Route path="/auctions/:id/:uid/lots" element={
                                    <Lots/>
                                } />
                                <Route path="/auctions/:id/:uid/overview" element={
                                    <AnimatedPage>
                                        <Overview/>
                                    </AnimatedPage>
                                } />
                                <Route path="/auctions/:id/:uid/bidders" element={
                                    <Bidders/>
                                } />
                                <Route path="/auctions/:id/:uid/bids" element={
                                    <Suspense fallback={<BidsShimmer/>}>
                                        <BidsList/>
                                    </Suspense>

                                } />
                                <Route path="/auctions/:id/:uid/insights" element={
                                    <Insights />
                                } />
                                <Route path="/auctions/:id/:uid/sales" element={
                                    <Sales/>
                                } />
                                <Route path="/auctions/:id/:uid/telephone-bids" element={
                                    <TelephoneBids/>
                                } />
                                <Route path="/auctions/:id/:uid/absentee-bids" element={
                                    <AbsenteeBids/>
                                } />
                            </Route>
                            <Route path="/auctions/:id/:uid/order-details/:saleid" element={
                                <OrderDetails/>
                            } />
                            <Route path="/allsales/:saleid" element={
                                <OrderDetails/>
                            } />
                            <Route path="/auctions/:id/:uid/bidders/:bidderId" element={
                                <BidderDetails/>
                            } />
                            <Route path="/allbidders/:bidderId" element={
                                <BidderDetails/>
                            } />
                        </Route>
                        <Route path="/auctions/:type/create" element={
                            <Suspense fallback={<PricingShimmer/>}>
                                <AnimatedPage>
                                    <CreateAuction/>
                                </AnimatedPage>
                            </Suspense>} />
                        
                        <Route path="/auctions/:id/:uid/lots/create" element={
                            <Suspense fallback={<PricingShimmer/>}>
                                <AnimatedPage>
                                    <CreateLot/>
                                </AnimatedPage>
                            </Suspense>} />
                        <Route path="/auctions/:id/:uid/lots/:lotNumber" element={
                            <Suspense fallback={<PricingShimmer/>}>
                                <AnimatedPage>
                                    <CreateLot edit/>
                                </AnimatedPage>
                            </Suspense>} />

                        <Route 
                            path={`/auctions/timed/create/:template`} 
                            element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <ClassicTemplate/>
                                    </AnimatedPage>
                                </Suspense>
                            }
                        />
                        {(price=="Pro") && <Route 
                            path={`/auctions/live/create/:template`} 
                            element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <LiveAuctionCreator/>
                                    </AnimatedPage>
                                </Suspense>
                            }
                        />}
                        {price=="Pro" && <Route 
                            path={`/auctions/type`} 
                            element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <ChooseType />
                                    </AnimatedPage>
                                </Suspense>
                            }/>
                        }

                        <Route 
                            path={`/auctions/timed/edit/:id/:uid/:template`} 
                            element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <ClassicTemplate edit />
                                    </AnimatedPage>
                                </Suspense>
                            }
                        />
                        <Route 
                            path={`/auctions/live/edit/:id/:uid/:template`} 
                            element={
                                <Suspense fallback={<PricingShimmer/>}>
                                    <AnimatedPage>
                                        <LiveAuctionCreator edit />
                                    </AnimatedPage>
                                </Suspense>
                            }
                        />
                        <Route path="/auctions/:id/:uid/carousel-view" element={
                            <CarouselView/>
                        } />
                        <Route path="/auctions/:id/:uid/leaderboard" element={
                            <LeaderBoardView/>
                        } />
                    </>
                )
            }
        </Routes>
    );
}
